<template>
  <div class="container_avatar" >
      <img :src="avatarUrl" style="borderRadius: 50% width: 100%; height: 100%">
  </div>
</template>

<script>
export default {
  name: "Avatar",
  props: {
    avatarUrl: {
      type: String
    },
  },
  data() {
    return {
    };
  },
  methods: {
  },
  computed: {
  },
  watch: {
  },
  created() {},
  mounted() {},
  beforeDestroy() {},
};
</script>

<style scoped>
 .container_avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 0;
  width: 100%;
  height: 100%;
  padding-bottom: 0;
  cursor: pointer;
 }
 img {
   cursor: default;
 }
</style>